/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 02/12/2013
 * Time: 12:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.controllers').
    controller('SiteCtrl', ["$scope", "$rootScope", "$locale", "DateSrv", "SiteData", "SiteView", "SiteSrv", "WorkingPeriod", "WorkingPeriodSrv", "WorkingPeriodView", "Site", "Auth", "HumanResourceData", "Constants", "HumanResourceView",
        function($scope,$rootScope,$locale,DateSrv,SiteData,SiteView,SiteSrv,WorkingPeriod,WorkingPeriodSrv,WorkingPeriodView,Site, Auth, HumanResourceData, Constants, HumanResourceView)
    {
        //Start-Init
        $scope.daysOfWeekLabel = DateSrv.daysOfWeekLabel;
        $scope.dd =
            {
                siteView : null,
                companyView : null,
                hours : [],
                hourQuarters : [],
                edited : {siteView : null},//edited site
                displayError : false,
                displayPhoneError : false,
                displayWPError : false ,
                displayWPIntersectError : false,
                displayWPPeriodError : false,
                displayWPMinDaysError:false,
                displayDesc:1,
                workingPeriodDayViewsToClose: [],
                humanResources: HumanResourceData.getActiveList(),
                ownerHumanResourceView: null,
                isAddressDifferentFromHeadOffice: null,
                countries: Constants.SITE_COUNTRIES,
                phoneCountry: null,
                isLoading: false,
            };

        $scope.checkAddressDifferentHeadOffice = function() {
            return $scope.dd.siteView.address !== $scope.dd.siteView.legalAddress ||
              $scope.dd.siteView.city !== $scope.dd.siteView.legalCity ||
              $scope.dd.siteView.country !== $scope.dd.siteView.legalCountry ||
              $scope.dd.siteView.postalCode !== $scope.dd.siteView.legalZip
        }

        $scope.updateIsAddressDifferentFromHeadOffice = function() {
            $scope.isAddressDifferentFromHeadOffice = !$scope.isAddressDifferentFromHeadOffice;
            $scope.updateLegalAddressSameAddress();
        }

        $scope.updateLegalAddressSameAddress = function() {
            if (!$scope.dd.isAddressDifferentFromHeadOffice) {
                $scope.dd.siteView.legalAddress = $scope.dd.siteView.address;
                $scope.dd.siteView.legalCity = $scope.dd.siteView.city;
                $scope.dd.siteView.legalCountry = $scope.dd.siteView.country;
                $scope.dd.siteView.legalZip = $scope.dd.siteView.postalCode;
            }
        }

        $scope.$watch('ad.dataLoaded', function(newValue, oldValue) {
            if (newValue) {
                if (!$scope.ad.managerMode) {
                    $scope.goToDomain("planningPos", "dashboard");
                }
                $scope.dd.siteView = new SiteView(SiteData.defaultSite);
                if (!$scope.dd.siteView.ownerId) {
                    const humanResource = HumanResourceData.getFirstActive();
                    $scope.dd.siteView.ownerId = humanResource ? humanResource.id : null;
                }
                $scope.dd.phoneCountry = $scope.dd.siteView.country.toLowerCase();
                $scope.updateOwner();
                $scope.dd.isAddressDifferentFromHeadOffice = $scope.checkAddressDifferentHeadOffice();
                $scope.dd.edited.siteView = $scope.dd.siteView;
            }
        });

        //Implement userActionCanceler
        const userActionCancelFn = $rootScope.$on('userActionCancel', function(_,actionCanceledType, object)
        {
            if (object instanceof Site)
            {
                $scope.dd.siteView.loadDataFrom(object)
            }
        });
        $scope.newWorkingHour = function ()
        {
            $scope.dd.displayWPError = false;
            $scope.currentWpView = new WorkingPeriodView();
            $scope.newWorkingHourMode = true;
        };

        $scope.removeWorkingPeriod = function (wpView)
        {
            $scope.dd.siteView.removeWorkingPeriodView(wpView);
        };

        $scope.toggleOpenDay = function(wpDayView, newOpenDayValue) {
            if(wpDayView.openDay && !newOpenDayValue) {
                $scope.dd.workingPeriodDayViewsToClose.push(wpDayView);
            } else if(!wpDayView.openDay && newOpenDayValue) {
                const wpIndex = $scope.dd.workingPeriodDayViewsToClose.indexOf(wpDayView)
                if(wpIndex != -1) {
                    $scope.dd.workingPeriodDayViewsToClose.splice(wpIndex, 1);
                }
            }
            wpDayView.openDay = newOpenDayValue;
        };

        $scope.saveSite = function () {
            if ($scope.dd.siteView.canSave($scope.ad.addons.sub.websiteAccess)
              && $scope.canSaveHumanResource()
              && !$scope.dd.displayPhoneError
              && !$scope.currentWpView && !$scope.isReadOnly()) {
                $scope.dd.isLoading=true;
                $scope.dd.siteView.updateModel($scope.dd.workingPeriodDayViewsToClose, $scope.finishSave, $scope.finishSave);
            }
        };

        $scope.finishSave = function () {
            $scope.dd.isLoading = false;
            $scope.dd.edited.siteView = null;
        }

        $scope.canSave = function (wpView){
            if(wpView && wpView.period.end.dateTime && wpView.period.start.dateTime){
                return true;
            }
            return false;
        };

        $scope.canSaveHumanResource = function() {
            return $scope.dd.ownerHumanResourceView && $scope.dd.ownerHumanResourceView.email && $scope.dd.ownerHumanResourceView.email !== '' && $scope.dd.ownerHumanResourceView.phone !== '' && $scope.dd.ownerHumanResourceView.phone;
        }

        $scope.checkIsAdminNotGroup = function() {
            return Auth.isAdminNotGroup();
        }


        $scope.saveWorkingPeriod = function (wpView) {
            if (wpView)
            {
                if (wpView.nbOpenDays()==0)
                {
                    $scope.dd.displayWPMinDaysError = true;
                    return;
                }
                if (wpView.period.start.getTime()>=wpView.period.end.getTime())
                {
                    $scope.dd.displayWPPeriodError = true;
                    return;
                }
                if ($scope.dd.siteView.intersectWorkingPeriodsView(wpView))
                {
                    $scope.dd.displayWPIntersectError = true;
                    return;
                }
                $scope.dd.displayWPMinDaysError = false;
                $scope.dd.displayWPIntersectError = false;
                $scope.dd.displayWPPeriodError = false;
                if (wpView.modelIndex==-1) // new item
                    $scope.dd.siteView.addWorkingPeriodView(wpView);

                //Update view
                wpView.edit=false;
                $scope.currentWpView = null;
                $scope.newWorkingHourMode = false;
                wpView.update();
            }


        };
        $scope.setCurrentWorkingPeriod = function (wpView) {
            $scope.currentWpView = wpView;
            wpView.edit = true;
        };

        $scope.cancelWorkingPeriod = function () {
            if ($scope.currentWpView) {
                $scope.currentWpView.edit = false;
            }
            $scope.currentWpView = null;
            $scope.currentWp = null;

            $scope.dd.displayWPMinDaysError = false;
            $scope.dd.displayWPIntersectError = false;
            $scope.dd.displayWPPeriodError = false;

        };

        $scope.displayError = function()
        {
            if(!$scope.dd.siteView.name || $scope.dd.siteView.name=='')
                $scope.dd.displayError = true;
            else
                $scope.dd.displayError = false;

            if($scope.dd.siteView.workingPeriodsView.length < 1)
                $scope.dd.displayWPError = true;
            else
                $scope.dd.displayWPError = false;

            if($scope.dd.edited.siteView && $scope.dd.edited.siteView.hasValidWorkPhone())
                $scope.dd.displayPhoneError = false;
            else
                $scope.dd.displayPhoneError = true;
        };

        $scope.$on('$destroy', function () {
            userActionCancelFn();
        });

        $scope.updateOwner = function() {
            if ($scope.dd.siteView && $scope.dd.siteView.ownerId) {
                let humanResource = HumanResourceData.getById($scope.dd.siteView.ownerId);
                $scope.dd.ownerHumanResourceView = new HumanResourceView(humanResource, HumanResourceData.getIndexOf(humanResource));
            }
        }

        $scope.updateTimezone = function() {
            let country = $scope.dd.countries.find((country) => country.code == $scope.dd.siteView.country);
            $scope.dd.siteView.timeZone = country.timezone;
        }
    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/siteCtrl.js